/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import { Box3, Vector3 } from "three";
const AFRAME = window.AFRAME;

if (!AFRAME.components.centerobject)
    AFRAME.registerComponent("centerobject", {
        schema: {
            precision: { type: "number", default: 2.5 },
            alert: { type: "boolean", default: false }
        },
        init: function () {
            this.el.setAttribute("visible", false);
            this.el.setAttribute("position", "0 0 0");
            this.tock = AFRAME.utils.throttleTick(this.tock, 100, this);
        },

        tock: function () {

            try {
                // Need to project the mesh in the world space
                const clonedObject = this.el.object3D.clone();
                // Getting bounding box
                this.bbox = new Box3().setFromObject(clonedObject);
                if (
                    !this.bbox ||
                    isNaN(this.bbox.max.x) ||
                    this.bbox.max.x === Infinity ||
                    this.bbox.max.x === -Infinity
                )
                    return;
                const vc = new Vector3();
                this.previousCenter = this.center;
                this.center = this.bbox.getCenter(vc);
                this.center.x = +this.center.x;
                this.center.y = +this.center.y;
                this.center.z = +this.center.z;

                const vs = new Vector3();
                this.size = this.bbox.getSize(vs);
            } catch (err) {
                this.bbox = null;
                console.error("error centerobject", err);
                return;
            }
            if (this.bbox && !isNaN(this.bbox.max.x)) {
                if (
                    this.previousCenter &&
                    this.inRange(this.center.x, this.previousCenter.x) &&
                    this.inRange(this.center.y, this.previousCenter.y) &&
                    this.inRange(this.center.z, this.previousCenter.z)
                ) {
                    this.el.setAttribute("position", {
                        x: -this.center.x,
                        y: -this.center.y,
                        z: -this.center.z + this.size.z / 2 + 0.01
                    });
                    this.el.removeAttribute("centerobject");
                }
                return;
            }
        },
        remove: function () {
            this.el.setAttribute("visible", "true");
            this.el.setAttribute("panelfinished", true);
            if (this.data.alert) this.el.emit("isLoaded", false);
        },

        inRange: function (x, target) {
            return (
                (x - (target / 100) * (100 - this.data.precision)) *
                    (x - (target / 100) * (100 + this.data.precision)) <=
                0
            );
        }
    });
